import { colors, screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

export interface PriceBubbleProps {
  price: string | null;
}

function PriceBubble({ price }: PriceBubbleProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="price-box-container">
      <div className="price-box">
        <div className="price-box-rectangle">
          <div className="price-box-text">
            <div className="listing">{t('vdp.thisVehicle')}</div>
            <div className="price">{price}</div>
          </div>
        </div>
        <div className="price-box-carat" />
      </div>
      <style jsx>{`
        .price-box-container {
          position: relative;
          display: flex;
          justify-content: center;
        }

        .price-box-text {
          z-index: 3;
          position: absolute;
          width: 106px;
          height: 53px;
          border-radius: 8px;
          margin-left: auto;
          margin-right: auto;
          top: 6px;
          left: 3px;
          right: 0;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: ${colors.WHITE};
        }

        @media (min-width: ${screen.smMin}) {
          .price-box-text {
            top: 10px;
            left: 0px;
            width: 142px;
            height: 62px;
          }
        }

        .listing {
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 600;
          color: ${colors.BLACK};
          letter-spacing: 0.2px;
        }

        @media (min-width: ${screen.smMin}) {
          .listing {
            font-size: 14px;
          }
        }

        .price {
          font-size: 22px;
          font-weight: 700;
          color: ${colors.BLACK};
          letter-spacing: 0.2px;
          margin-top: -2px;
        }

        @media (min-width: ${screen.smMin}) {
          .price {
            font-size: 24px;
          }
        }

        .price-box {
          position: relative;
          width: 112px;
          height: 69px;
        }

        @media (min-width: ${screen.smMin}) {
          .price-box {
            width: 144px;
            height: 82px;
          }
        }

        .price-box-rectangle {
          width: 112px;
          height: 60px;
          z-index: 1;
          background: ${colors.WHITE};
          border: 1px solid ${colors.G2};
          border-radius: 8px;
          box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
        }

        @media (min-width: ${screen.smMin}) {
          .price-box-rectangle {
            width: 144px;
            height: 71.92px;
          }
        }

        .price-box-carat {
          position: absolute;
          width: 27.98px;
          height: 27.98px;
          left: 41px;
          top: 38px;
          transform: matrix(0.71, -0.7, 0.72, 0.71, 0, 0);
          background: ${colors.WHITE};
          border: 1px solid ${colors.G2};
          border-radius: 3px;
          box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.05);
        }

        @media (min-width: ${screen.smMin}) {
          .price-box-carat {
            left: 55px;
            top: 50px;
          }
        }
      `}</style>
    </div>
  );
}

export default PriceBubble;
